import { Injectable } from '@angular/core';
import { SettingsComponent } from '@firebird-web/settings';
import { DialogService } from '@firebird-web/shared-ui';
import { FavoriteList } from '../../../../custom-locations-store/src/lib/models/favorite-locations.types';
import { SETTINGS_DIALOG_CONFIG } from '../constants';
import { CustomListEditorService } from './custom-list-editor.service';

@Injectable()
export class SettingsService {
  constructor(
    private readonly dialogService: DialogService,
    private readonly customListEditor: CustomListEditorService
  ) {}

  public openManageCustomList(): void {
    this.dialogService.openDialog({
      component: SettingsComponent,
      title: 'settings',
      params: { labelKey: 'favoriteLocations', isActive: true },
      config: SETTINGS_DIALOG_CONFIG,
    });
  }

  public openCustomListEditor(list: FavoriteList): void {
    this.customListEditor.open(list);
  }
}
